// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_shared_models_reset-password-user_ts-src_app_shared_services_document-service-5f7479":"ab809ba6b54da394","src_app_views_dashboard_dashboard_module_ts":"afb934f9ee46e51c"}[chunkId] + ".css";
};